export const getDropdownStyle = (dropdownInfo, colorObj) => ({
    position: "fixed",
    top: dropdownInfo.top,
    left: dropdownInfo.left,
    minWidth: dropdownInfo.width,
    maxHeight: "80vh",
    overflowY: "scroll",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    zIndex: 9,
    "--primary_color": colorObj?.primary_color,
    "--accent_color2": colorObj?.accent_color2,
    "--accent_color3": colorObj?.accent_color3,
    "--accent_color4": colorObj?.accent_color4,
    "--background_color": colorObj?.background_color,
});
